import { api } from './client';
import type { StatsByEnv } from '../types';

export function fetchStats() {
  return api<StatsByEnv>(`/stats`);
}
